import { FormViewModeType } from '@grouper/modules/database/formViewModeTypes'
import FormViewModeSurvey from '@grouper_premium/components/views/form/FormViewModeSurvey'
import FormViewModePreviewSurvey from '@grouper_premium/components/views/form/FormViewModePreviewSurvey'
import PremiumFeatures from '@grouper_premium/features'
import PaidFeaturesModal from '@grouper_premium/components/PaidFeaturesModal'
import { FormSurveyModePaidFeature } from '@grouper_premium/paidFeatures'

export class FormViewSurveyModeType extends FormViewModeType {
  static getType() {
    return 'survey'
  }

  getName() {
    const { $i18n } = this.app
    return $i18n.t('formViewModeType.survey')
  }

  getDescription() {
    const { $i18n } = this.app
    return $i18n.t('formViewModeType.surveyDescription')
  }

  getIconClass() {
    return 'iconoir-reports'
  }

  getDeactivatedText() {
    const { $i18n } = this.app
    return $i18n.t('formViewModeType.onlyForPremium')
  }

  getDeactivatedClickModal() {
    return [
      PaidFeaturesModal,
      { 'initial-selected-type': FormSurveyModePaidFeature.getType() },
    ]
  }

  isDeactivated(workspaceId) {
    return !this.app.$hasFeature(PremiumFeatures.PREMIUM, workspaceId)
  }

  getFormComponent() {
    return FormViewModeSurvey
  }

  getPreviewComponent() {
    return FormViewModePreviewSurvey
  }
}
